module.exports = __webpack_public_path__ + "img/delete_table.820c3c29.svg";